import type { PipeOption } from '../../../../ndt/components/FilterPanel';
import type { WeldData } from '../../../../../components/WeldDataTable';
import type { WeldDrillDownRow } from './drillDownTypes';

function statusFieldToString(value: string | boolean | null | undefined): string {
  if (value == null) return '';
  if (typeof value === 'boolean') return value ? 'TRUE' : 'FALSE';
  return value;
}

export function mapDrillDownRowToWeldData(
  row: WeldDrillDownRow,
  pipeId: string | null,
  pipeOptions: PipeOption[] = [],
): WeldData {
  const selectedPipe = pipeId
    ? pipeOptions.find((p) => String(p.pipeId) === String(pipeId)) ?? { pipeId }
    : null;

  const durationMin =
    row.durationSec != null ? (row.durationSec / 60).toFixed(2) : '0';

  const prod = row.productionRow;

  return {
    id: Number(prod?.id) || 0,
    weldNumber: row.weldNumber,
    weldIdentifier: row.weldNumber,
    wpsNumber: row.wpsNumber,
    status: row.outcome === 'fail' ? 'Rejected' : row.outcome === 'pass' ? 'Completed' : '-',
    weldTime: `${durationMin} min`,
    startTime: row.startTimeMs != null ? Math.floor(row.startTimeMs / 1000) : 0,
    endTime: row.endTimeMs != null ? Math.floor(row.endTimeMs / 1000) : 0,
    projectId: row.projectId ?? 0,
    projectName: row.projectName,
    statusByInstantaneous: statusFieldToString(row.statusByInstantaneous),
    statusByAvgZone: statusFieldToString(row.statusByAvgZone),
    statusByAvgPass: statusFieldToString(row.statusByAvgPass),
    statusByAvgTilt: statusFieldToString(row.statusByAvgTilt),
    gps: prod?.gps != null ? String(prod.gps) : null,
    minDistance: prod?.minDistance != null ? Number(prod.minDistance) : null,
    numOfGpsPoints: prod?.numOfGpsPoints != null ? Number(prod.numOfGpsPoints) : null,
    pipeDiameter: row.pipeDiameter != null ? Number(row.pipeDiameter) : null,
    wallThickness: row.wallThickness != null ? Number(row.wallThickness) : null,
    selectedPipe,
  };
}
